import config from "../../src/common/default_config";

export default class options extends config {
  static page_width_reference = 2650000;
  static page_height_reference = 3650000;
  static page_ratio = 1.36682128906;
  static subscriptionOptions = {
    subscriptionType: "subscription",
    subscriptionProvider: "TEL",
  };
  static displayHorsSerieArchive = false;
  static usePromoSpot = false;
  static channel = 1;
  static displayKiosqueIframeBanner = false;
  static cookieEnabled = true;
  static editor = "Le Télégramme";
  static homeRedirectionLink = "//www.letelegramme.fr/journal/";
  static printArticle = true;
  static enrichment_placement_vertical = "bottom"; // [top || bottom || center];
  static enrichment_placement_horizontal = "right"; // [left || right || center];
  //pdf
  static usePdfDesktop = true;
  static usePdfPhoneNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static usePdfPhone = true;
  static usePdfTabletNot = [
    ["Safari", "iOS", "version_8"],
    ["Safari", "iOS", "version_7"],
  ];
  static replicaReadingModeToggle = {
    phone: false,
    tablet: true,
    desktop: true,
  };
  static replicaReadingModeDefault = {
    phone: false,
    tablet: false,
    desktop: true,
  };
  static usePdfTablet = true;
  static touchDownloadPdf = true;
  static fullPdfDownloadOnly = true;

  static SSOCookieName = "LTRToken";
  static SSOEnabled = true;
  static SSOCookieOptions = { path: "", domain: ".letelegramme.fr" };

  static product_name_for_engage_readers = "Quotidien";
  static defaultPreferredViewer = "replica";
}



// WEBPACK FOOTER //
// ./clients/tel-tel/config.js